// extracted by mini-css-extract-plugin
export default {"wrapperReferralSuccess":"ReferralSuccess_wrapperReferralSuccess__V098C","marginB":"ReferralSuccess_marginB__+jBC+"};